/* iSpice Deals page - 2026-10-07
   Motion and the working parts for sections/ispice-deals.liquid:
   - reveal on scroll + numbers counting up (skipped for "reduce motion")
   - the banner's gift sets follow the mouse a little (desktop only)
   - events: past ones hide, the live one shows "ends in", the next one shows "starts in" (days/hours/min/sec)
   - gift sets: pack-size filters built from the products, sort, add to cart with /cart/add.js
   All words come from the section settings (the <template data-isx-dl-words> attributes). */
(function () {
  'use strict';
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var words = (root.querySelector('[data-isx-dl-words]') || {}).dataset || {};
    root.classList.add('is-js');

    /* reveal + count up */
    function countUp(el) {
      var to = +el.getAttribute('data-count') || 0;
      if (still || !to) { el.textContent = to; return; }
      var t0 = null, dur = 1400;
      function step(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(to * e);
        if (k < 1) requestAnimationFrame(step);
      }
      el.textContent = '0';
      requestAnimationFrame(step);
    }
    var seen = function (el) {
      el.classList.add('is-in');
      Array.prototype.forEach.call(el.querySelectorAll('[data-count]'), countUp);
    };
    var rises = root.querySelectorAll('.isx-dl-rise');
    if ('IntersectionObserver' in window && !still) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { seen(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      Array.prototype.forEach.call(rises, function (el) { io.observe(el); });
    } else {
      Array.prototype.forEach.call(rises, seen);
    }
    var heroCount = root.querySelector('.isx-dl-hero [data-count]');
    if (heroCount) setTimeout(function () { countUp(heroCount); }, 500);

    /* banner gift sets drift with the mouse */
    var stage = root.querySelector('[data-isx-dl-float]');
    if (stage && !still && window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {
      var hero = root.querySelector('[data-isx-dl-hero]'), floats = stage.querySelectorAll('.isx-dl-float');
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        Array.prototype.forEach.call(floats, function (f, i) {
          var depth = [18, 10, 26][i] || 14;
          f.style.setProperty('--px', (x * depth).toFixed(1) + 'px');
          f.style.setProperty('--py', (y * depth).toFixed(1) + 'px');
        });
      });
      hero.addEventListener('pointerleave', function () {
        Array.prototype.forEach.call(floats, function (f) { f.style.setProperty('--px', '0px'); f.style.setProperty('--py', '0px'); });
      });
    }

    /* events */
    var evs = Array.prototype.slice.call(root.querySelectorAll('.isx-dl-event'));
    function day(s, endOfDay) {
      var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(s || '').trim());
      if (!m) return null;
      return endOfDay ? new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59) : new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0);
    }
    var clockEl = null, clockTo = null, clockWord = '';
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      if (!clockEl) return;
      var s = Math.max(0, Math.floor((clockTo - new Date()) / 1000));
      if (!s) { setupEvents(); return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
      var u = (words.units || 'days,hrs,min,sec').split(',');
      clockEl.innerHTML = '<span>' + clockWord + '</span><i><b>' + d + '</b><small>' + u[0] + '</small></i><i><b>' + pad(h) + '</b><small>' + (u[1] || '') + '</small></i><i><b>' + pad(m) + '</b><small>' + (u[2] || '') + '</small></i><i><b>' + pad(x) + '</b><small>' + (u[3] || '') + '</small></i>';
    }
    function setupEvents() {
      if (!evs.length) return;
      var now = new Date(), shown = 0, clocked = false;
      clockEl = null;
      evs.forEach(function (li) {
        var st = day(li.getAttribute('data-start')), en = day(li.getAttribute('data-end'), true) || (st && new Date(st.getTime() + 86399000));
        var c = li.querySelector('[data-clock]'), state = li.querySelector('[data-state]');
        c.hidden = true;
        li.classList.remove('is-live');
        if (en && en < now) { li.hidden = true; return; }
        li.hidden = false; shown++;
        var live = st && st <= now;
        if (live) { li.classList.add('is-live'); state.textContent = words.live || 'On now'; }
        else { state.textContent = words.soon || 'Coming up'; }
        if (!clocked && (live ? en : st)) {
          clocked = true; clockEl = c; c.hidden = false;
          clockTo = live ? en : st; clockWord = live ? (words.ends || 'Ends in') : (words.starts || 'Starts in');
        }
      });
      var none = root.querySelector('[data-isx-dl-noevents]');
      if (none) none.hidden = shown > 0;
      tick();
    }
    setupEvents();
    if (evs.length) setInterval(tick, 1000);

    /* gift sets: filters + sort */
    var grid = root.querySelector('[data-isx-dl-grid]');
    if (grid) {
      var items = Array.prototype.slice.call(grid.children);
      var chips = root.querySelector('[data-isx-dl-chips]');
      var packs = items.map(function (li) { return +li.getAttribute('data-pack') || 0; })
        .filter(function (n, i, a) { return n > 0 && a.indexOf(n) === i; }).sort(function (a, b) { return a - b; });
      if (chips && packs.length > 1) {
        packs.forEach(function (n) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'isx-dl-chip'; b.setAttribute('data-pack', n); b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', 'false');
          b.textContent = n + ' ' + (words.pack || 'pack');
          chips.appendChild(b);
        });
      } else if (chips) { chips.hidden = true; }
      if (chips) chips.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pack]'); if (!b) return;
        Array.prototype.forEach.call(chips.children, function (c) { var on = c === b; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', String(on)); });
        var want = b.getAttribute('data-pack');
        items.forEach(function (li) { li.classList.toggle('is-out', want !== 'all' && li.getAttribute('data-pack') !== want); li.classList.add('is-in'); });
      });
      var sortSel = root.querySelector('[data-isx-dl-sort]');
      function sortBy(how) {
        items.sort(function (a, b) {
          var pa = +a.dataset.price, pb = +b.dataset.price;
          if (how === 'low') return pa - pb;
          if (how === 'high') return pb - pa;
          return (+b.dataset.pct - +a.dataset.pct) || (+a.dataset.i - +b.dataset.i);
        });
        items.forEach(function (li) { grid.appendChild(li); });
      }
      sortBy('save');
      if (sortSel) sortSel.addEventListener('change', function () { sortBy(sortSel.value); items.forEach(function (li) { li.classList.add('is-in'); }); });
    }

    /* add to cart */
    var toast = root.querySelector('[data-isx-dl-toast]'), toastTxt = root.querySelector('[data-isx-dl-toast-text]'), toastT;
    function say(msg) {
      if (!toast) return;
      toastTxt.textContent = msg; toast.hidden = false;
      toast.style.animation = 'none'; void toast.offsetWidth; toast.style.animation = '';
      clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 5000);
    }
    function refreshCount() {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        Array.prototype.forEach.call(document.querySelectorAll('.header-cart__count, [data-cart-count]'), function (el) { el.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
      }).catch(function (e) { console.warn('ispice-deals cart count', e); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-isx-dl-add]'); if (!b || b.disabled) return;
      var label = b.textContent;
      b.disabled = true; b.textContent = words.adding || 'Adding…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.getAttribute('data-isx-dl-add'), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () {
          b.classList.add('is-done'); b.textContent = '✓';
          refreshCount();
          // the site's own "Added to your cart" panel (ispice-cart.js) opens about 1s later; only speak up when it didn't
          setTimeout(function () {
            if (!document.querySelector('.isc-drawer.is-open')) say((words.added || '[name] is in your cart').replace('[name]', b.getAttribute('data-name') || ''));
          }, 2000);
          setTimeout(function () { b.classList.remove('is-done'); b.textContent = label; b.disabled = false; }, 1600);
        })
        .catch(function (err) {
          console.warn('ispice-deals add', err);
          b.textContent = label; b.disabled = false;
          say(words.failed || 'Sorry, that could not be added. Please try again.');
        });
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-isx-dl]'), function (root) {
      if (root.dataset.isxDone) return;
      root.dataset.isxDone = '1';
      try { init(root); } catch (e) { console.warn('ispice-deals', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
